export enum FontFamilyToken {
  inter = 'Inter',
  montserrat = 'Montserrat',
}

export default FontFamilyToken
